import React from 'react'

export default function OverlayImageStack ({ urls }) {
  if (!urls || urls.length === 0) {
    return null
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        pointerEvents: 'none',
        zIndex: 10
      }}
    >
      {urls.map((url) => (
        <img
          key={url}
          src={url}
          alt=''
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            objectFit: 'contain'
          }}
        />
      ))}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/OverlayImageStack.js